import { content } from '../../content';

const buildDesktopCareersLink : any = () => {
    let careersListItem = document.createElement('li');
    careersListItem.className = content.MORE_LINKS.careersLink.desktop.class;
    careersListItem.setAttribute('role','menuitem')
    careersListItem.setAttribute('tabindex','-1')
    careersListItem.innerHTML = content.MORE_LINKS.careersLink.desktop.innerHTML;
    return careersListItem;
}

const addDesktopCareersLink = () => {
    let moreMenuList = document.querySelector('#header-helpful-links-menu .header-footer-menu-list') as HTMLElement;
    let careersLink = document.querySelector('#header-helpful-links-menu .header-link__careers-link') as HTMLElement;

    if(moreMenuList && !careersLink) {
        moreMenuList.appendChild(buildDesktopCareersLink());
    }
}

export const setDesktopContent = () => {
    removeCareersLinks();
    addDesktopCareersLink();
}

const removeCareersLinks = () => {
    let careersLink = document.querySelector('.header-link__careers-link') as HTMLElement;
    if(careersLink) {
        careersLink.remove();
    }
}
